"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopChips = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _FeaturedTag = require("./FeaturedTag");
var _ProductStatus = require("./ProductStatus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TopChips = function TopChips(props) {
  var product = props.product;
  var FeaturedTag = props.featuredTagComponent || _FeaturedTag.FeaturedTag;
  var ProductStatus = props.productStatusComponent || _ProductStatus.ProductStatus;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    direction: "column",
    alignItems: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(ProductStatus, {
    product: product
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(FeaturedTag, {
    product: product,
    displayPosition: "right"
  })), props.renderExtraChips && props.renderExtraChips(product));
};
exports.TopChips = TopChips;